const data = {
	// street gallery data
	galleryStreetArtTheWallData: [
		{
			id: 1,
			src: "img/street-art/street-art-the-wall/street-01/street_01",
			type: "jpg",
			header: "Den røde kjole",
			paragraf: "Denne smukke kvinde, kunne lige så godt være malet enten af Arne haugen sørensen eller Leif Sylvester",
		},
		{
			id: 2,
			src: "img/street-art/street-art-the-wall/street-01/street_02",
			header: "Venner",
			paragraf: "Venner, der hvor regnbuen ender",
		},
		{
			id: 3,
			src: "img/street-art/street-art-the-wall/street-01/street_03",
			header: "Ansigt på ansigt",
			paragraf: "Hvor mange ansigter er der egentlig?",
		},
		{
			id: 4,
			src: "img/street-art/street-art-the-wall/street-01/street_04",
			header: "Hund i natten",
			paragraf: "Hund måne og nattelige gøremål",
		},
		{
			id: 5,
			src: "img/street-art/street-art-the-wall/street-01/street_05",
			header: "Ansigtet er sjælens spejl",
			paragraf: "Som om man kigger ind i et uroligt sind",
		},
		{
			id: 6,
			src: "img/street-art/street-art-the-wall/street-01/street_06",
			header: "Glæde er livets kilde",
			paragraf: "Et orgie af farver, livsglæde og latter",
		},
		{
			id: 7,
			src: "img/street-art/street-art-the-wall/street-01/street_07",
			header: "Portræt i sort og hvid",
			paragraf: "Udtryktsfuldt sort hvidt ansigt, men med et orgie af farver i baggrunden",
		},
		{
			id: 8,
			src: "img/street-art/street-art-the-wall/street-01/street_08",
			header: "Med næsen i sky",
			paragraf: "Kvinde, fugl og et næsten drømmende ansigt på vej gennem verden",
		},
		{
			id: 9,
			src: "img/street-art/street-art-the-wall/street-01/street_09",
			header: "En tegneserie drøm",
			paragraf: "Man kan næsten blive ved med at, finde nye figure og detaljer i dette tegneserie inspireret street art",
		},
	],
	galleryStreetArtText: {
		// header: "Berlin er et overflødighedshorn af street art ",
		header: "Berlinmuren",
		subHeader:
			"Berlin er et overflødighedshorn af street art, men især en del af den gamle mur ved Mühlenstrasse, er et besøg værd",
	},
	// street gallery data 2
	galleryStreetArtTheWallData02: [
		{
			id: 1,
			src: "img/street-art/street-art-the-wall/street-02/street_01",
			header: "Overskrift",
			paragraf:
				"Lorem ipsum dolor, sit amet consectetur adipisicing elit Lorem ipsum dolor,<br /> sit amet consectetur adipisicing elit consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 2,
			src: "img/street-art/street-art-the-wall/street-02/street_02",
			header: "Overskrift",
			paragraf:
				"Lorem ipsum dolor, sit amet consectetur adipisicing elit Lorem ipsum dolor,<br /> sit amet consectetur adipisicing elit consectetur adipisicing elit Lorem ipsum dolor,consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 3,
			src: "img/street-art/street-art-the-wall/street-02/street_03",
			header: "Overskrift",
			paragraf: "Consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 4,
			src: "img/street-art/street-art-the-wall/street-02/street_04",
			header: "Overskrift",
			paragraf:
				"Lorem ipsum dolor, sit amet consectetur adipisicing elit Lorem ipsum dolor,<br /> sit amet consectetur adipisicing elit consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 5,
			src: "img/street-art/street-art-the-wall/street-02/street_05",
			header: "Overskrift",
			paragraf:
				"Lorem ipsum dolor, sit amet consectetur adipisicing elit Lorem ipsum dolor,<br /> sit amet consectetur adipisicing elit consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 6,
			src: "img/street-art/street-art-the-wall/street-02/street_06",
			header: "Overskrift",
			paragraf: "consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 7,
			src: "img/street-art/street-art-the-wall/street-02/street_07",
			header: "Overskrift",
			paragraf: "consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 8,
			src: "img/street-art/street-art-the-wall/street-02/street_08",
			header: "Overskrift",
			paragraf: "consectetur adipisicing elit Lorem ipsum ",
		},
		{
			id: 9,
			src: "img/street-art/street-art-the-wall/street-02/street_09",
			header: "Overskrift",
			paragraf:
				"consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 10,
			src: "img/street-art/street-art-the-wall/street-02/street_10",
			header: "Overskrift",
			paragraf:
				"consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 11,
			src: "img/street-art/street-art-the-wall/street-02/street_11",
			header: "Overskrift",
			paragraf:
				"consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 12,
			src: "img/street-art/street-art-the-wall/street-02/street_12",
			header: "Overskrift",
			paragraf:
				"consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor",
		},
		{
			id: 13,
			src: "img/street-art/street-art-the-wall/street-02/street_13",
			header: "Overskrift",
			paragraf:
				"consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor, consectetur adipisicing elit Lorem ipsum dolor consectetur adipisicing elit Lorem ipsum dolor",
		},
	],
	galleryStreetArtText02: {
		header: "Berlin muren og street art",
		// subHeader: "Berlin er et overflødighedshorn af street art, men især den del af den gamle mur som ligge ved Mühlenstrasse og som står som et mindesmærke om opdelingen af Tyskland i øst og vest, er et besøg værd"
	},

	galleryStreetArtBerlin: [
		{
			id: 1,
			src: "img/street-art/street-art-berlin/street_01",
			header: "Ansigtet på væggen",
			paragraf: "Ikke til at komme uden om, Mega ansigt skuer ud over gaden",
		},
		{
			id: 2,
			src: "img/street-art/street-art-berlin/street_10",
			header: "Naturen indvandrere byen",
			paragraf: "Sangfugl i mange farver, skaber live i den ellers grå betonmur",
		},
		{
			id: 3,
			src: "img/street-art/street-art-berlin/street_12",
			header: "Drømmen om det åbne hav",
			paragraf: "Delfinernes leg",
		},
		{
			id: 4,
			src: "img/street-art/street-art-berlin/street_11",
			header: "Ravnen og edderkoppen",
			paragraf:
				"Byen er befolket med mange forskellige dyr, fugle, insekter, mus, katte og nu også denne silhuet af en ravn",
		},
		{
			id: 5,
			src: "img/street-art/street-art-berlin/street_04",
			header: "Dans dans",
			paragraf: "Tango, dans og glæde",
		},
		{
			id: 6,
			src: "img/street-art/street-art-berlin/street_08",
			header: "Sejl ud",
			paragraf: "Berlin på Noahs ark",
		},
		{
			id: 7,
			src: "img/street-art/street-art-berlin/street_14",
			header: "Blå øjne",
			paragraf: "Øjet er sjælens spejl",
		},
	],
	galleryStreetArtBerlinText: {
		header: "Berlin street art",
		subHeader: "Gadekunst i Berlin kan findes over alt, fra det kæmpe store til det mindste",
	},
};

export default data;
